(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["ostove-countdown-announcement"] && !Shopify.designMode) return;
  try {
    (() => {
    const bar = document.querySelector('[data-countdown-announcement]');
    if (!bar) return;
    const end = Date.parse(bar.dataset.end);
    let timer;
    function expire() {
      if (Date.now() < end) return;
      clearTimeout(timer);
      bar.hidden = true;
    }
    expire();
    timer = setTimeout(expire, Math.min(end - Date.now(), 2147483647));
    document.addEventListener('visibilitychange', expire);
    window.addEventListener('focus', expire);
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ostove-countdown-promo"] && !Shopify.designMode) return;
  try {
    (() => {
    function initCountdownPromo() {
      const dialog = document.getElementById('ostove-countdown-promo');
      const reopen = document.getElementById('countdown-promo-reopen');
      if (!dialog || !reopen || typeof dialog.showModal !== 'function') return;
      const start = Date.parse(dialog.dataset.start);
      const end = Date.parse(dialog.dataset.end);
      const storageKey = 'ostove-countdown-p' + dialog.dataset.phase + '-seen';
      let showTimer;
      let expiryTimer;
      function active() { return Date.now() >= start && Date.now() < end; }
      function markSeen() { try { sessionStorage.setItem(storageKey, '1'); } catch (_) {} }
      function expire() {
        if (active()) return false;
        clearTimeout(showTimer);
        clearTimeout(expiryTimer);
        if (dialog.open) dialog.close();
        dialog.remove();
        reopen.remove();
        return true;
      }
      function open() {
        if (expire() || dialog.open) return;
        dialog.showModal();
        reopen.hidden = true;
        markSeen();
      }
      function close() { markSeen(); dialog.close(); }
      if (expire()) return;
      dialog.querySelector('[data-countdown-close]').addEventListener('click', close);
      dialog.querySelector('[data-countdown-shop]').addEventListener('click', markSeen);
      dialog.addEventListener('close', () => { markSeen(); reopen.hidden = !active(); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
      });
      reopen.addEventListener('click', open);
      document.addEventListener('visibilitychange', expire);
      window.addEventListener('focus', expire);
      expiryTimer = setTimeout(expire, Math.min(end - Date.now(), 2147483647));
      let seen = false;
      try { seen = sessionStorage.getItem(storageKey) === '1'; } catch (_) {}
      if (seen) reopen.hidden = false;
      else showTimer = setTimeout(open, 650);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initCountdownPromo, { once: true });
    else initCountdownPromo();
  })();
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__snippets__["ostove-oranje-promo"] && !Shopify.designMode) return;
  try {
    (() => {
    function initOranjePromo() {
      const dialog = document.getElementById('ostove-oranje-promo');
      const reopen = document.getElementById('oranje-promo-reopen');
      if (!dialog || !reopen || typeof dialog.showModal !== 'function') return;
      const start = Date.parse(dialog.dataset.start);
      const end = Date.parse(dialog.dataset.end);
      const storageKey = 'ostove-oranje-20260917-seen';
      let showTimer;
      let expiryTimer;
      function active() { return Date.now() >= start && Date.now() < end; }
      function markSeen() { try { sessionStorage.setItem(storageKey, '1'); } catch (_) {} }
      function expire() {
        if (active()) return false;
        clearTimeout(showTimer);
        clearTimeout(expiryTimer);
        if (dialog.open) dialog.close();
        dialog.remove();
        reopen.remove();
        return true;
      }
      function open() {
        if (expire() || dialog.open) return;
        dialog.showModal();
        reopen.hidden = true;
        markSeen();
      }
      function close() { markSeen(); dialog.close(); }
      if (expire()) return;
      dialog.querySelector('[data-oranje-close]').addEventListener('click', close);
      dialog.querySelector('[data-oranje-shop]').addEventListener('click', markSeen);
      dialog.addEventListener('close', () => { markSeen(); reopen.hidden = !active(); });
      dialog.addEventListener('click', event => {
        if (event.target !== dialog) return;
        const box = dialog.getBoundingClientRect();
        if (event.clientX < box.left || event.clientX > box.right || event.clientY < box.top || event.clientY > box.bottom) close();
      });
      reopen.addEventListener('click', open);
      document.addEventListener('visibilitychange', expire);
      window.addEventListener('focus', expire);
      expiryTimer = setTimeout(expire, Math.min(end - Date.now(), 2147483647));
      let seen = false;
      try { seen = sessionStorage.getItem(storageKey) === '1'; } catch (_) {}
      if (seen) reopen.hidden = false;
      else showTimer = setTimeout(open, 650);
    }
    if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', initOranjePromo, { once: true });
    else initOranjePromo();
  })();
  } catch(e) { console.error(e); }
})();

})();
